import { render, staticRenderFns } from "./f_genovesa.vue?vue&type=template&id=8ad90dc8"
import script from "./f_genovesa.vue?vue&type=script&lang=js"
export * from "./f_genovesa.vue?vue&type=script&lang=js"
import style0 from "./f_genovesa.vue?vue&type=style&index=0&id=8ad90dc8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports